module.exports = __webpack_public_path__ + "img/IMG_8291.e1f54487.jpg";